import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { CardMedia, CardContent } from '@mui/material'

import { OfferItemProps } from '../../../types/interface/offer.interface'
import { CustomCardHeader, ProductWrapper, Typography } from '@dg-shared'
import { exampleCarImg } from 'BrandedImages'
import { PartnerName, ProductName } from '../../../types/interface/quote.interface'
import { addSpaceRegNum } from '@dg-util'
import BaseCard from '../../../components/shared/BaseCard'

const IMG_TITLE = 'Example Car'

const useOffersStyles = makeStyles()((theme: Theme) => ({
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 3),
  },

  imageContainer: {
    marginBottom: theme.spacing(2),
  },

  image: {
    marginTop: theme.spacing(2),
    display: 'block',
  },

  subtitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },

  dateText: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1,
    marginTop: theme.spacing(0.5),
  },

  seePrice: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1,
    marginTop: theme.spacing(0.5),
    color: theme.palette.primary.main,
  },

  cardHeaderContainerStyle: {
    backgroundColor: theme.brand.colors.textSecondary,
    padding: theme.spacing(2.5, 3),
    '& > div': {
      marginTop: 0,
    },
    '& h2': {
      fontWeight: 700,
      lineHeight: 1,
    },
    ...theme.brand.assets.layout?.offerItemVehicleCardHeaderContainerStyle,
  },
}))

const OfferItem: FC<OfferItemProps> = ({
  vehicle,
  translations,
  customClassName,
  handleClick,
  showImage = true,
}) => {
  const { classes } = useOffersStyles()
  const carName = [vehicle.CarMake, vehicle.CarModel].filter(Boolean).join(' ')

  const header = (
    <CustomCardHeader
      titleTextType='h3'
      withPrice={false}
      title={translations.vehicleCardTitle || ''}
      containerClass={classes.cardHeaderContainerStyle}
    />
  )

  return (
    <BaseCard header={header} onClick={handleClick} testId='offer-card' className={customClassName}>
      {showImage && (
        <ProductWrapper
          partners={[PartnerName.instabank, PartnerName.circlek]}
          products={[ProductName.VEHICLE]}
        >
          <section className={classes.imageContainer}>
            <CardMedia
              component='img'
              className={classes.image}
              alt={IMG_TITLE}
              image={exampleCarImg}
              title={IMG_TITLE}
            />
          </section>
        </ProductWrapper>
      )}
      <CardContent className={classes.content}>
        {!!carName && (
          <Typography type='h3' className={classes.subtitle} testId='vehicle-title'>
            {carName}
          </Typography>
        )}
        {!!vehicle.MotorRegistrationNumber && (
          <Typography className={classes.dateText} testId='reg-num'>
            {addSpaceRegNum(vehicle.MotorRegistrationNumber)}
          </Typography>
        )}
        {!!translations.seePrice && (
          <Typography className={classes.seePrice} testId='see-price'>
            {translations.seePrice}
          </Typography>
        )}
      </CardContent>
    </BaseCard>
  )
}

export default OfferItem
